export default function AdminHotelEditBarService(
    $q,
    $window,
    l10nService
) {
    'ngInject';

        const CONFIRM_MESSAGE = 'Do you want to cancel changes?';

        Object.assign(this, {
            confirmCancellingChanges,
            showMessageIfUserClosesTab,
            dontShowMessageIfUserClosesTab,
            scrollToTheFirstSectionWithError,
        });

        function confirmCancellingChanges() {
            const message = l10nService.localize(CONFIRM_MESSAGE);
            return $window.confirm(message) ? $q.when() : $q.reject();
        }

        function showMessageIfUserClosesTab() {
            const message = l10nService.localize(CONFIRM_MESSAGE);
            $window.onbeforeunload = () => message;
        }

        function dontShowMessageIfUserClosesTab() {
            $window.onbeforeunload = null;
        }

        function scrollToTheFirstSectionWithError() {
            const scrollTop = getOffsetOfFirstSectionWithError() - 100;
            getBody().animate({scrollTop});

            function getBody() {
                return angular.element('html,body');
            }

            function getOffsetOfFirstSectionWithError() {
                const selector = 'input.ng-invalid:first';
                return angular.element(selector).offset().top;
            }
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-bar/admin-hotel-edit-bar-service.js